import { getDropdownDataFromArray } from "../utils/helpers";
import { DropdownType, ObjectType } from "./types";

export const ALLOWED_ROLES_ENUM: ObjectType = {
  SUPERADMIN: "superadmin",
  OPERATION_USER: "operationadmin",
  MEMBER: "member",
};

export const API_STATUS: ObjectType = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const APP_LIMITS = {
  MAX_ATTACHMENTS: 5,
  MAX_ATTACHMENT_SIZE: 1 * 1024 * 1024, //1 MB
};

export const DROPDOWN_TYPES_ENUM: ObjectType = {
  ENTITIES: "entities",
  SURNAMES: "surnames",
  HEAD_MEMBERS: "headMembers",
  ROLES: "roles",
  MENUS: "menus",
  OPERATION_USERS: "operationUsers",
  EDUCATION: "education",
  OCCUPATION: "occupation",
};

export const ENTITY_TYPES: { [key: string]: string } = {
  GENDER: "genderOptions",
  MARITAL_STATUS: "maritalstatusOptions",
  BLOOD_GROUP: "bloodgroupOptions",
  MEMBER_RELATION: "memberrelationOptions",
  MEMBER_STATUS: "memberstatusOptions",
  LANGUAGE: "languageOptions",
  EDUCATION: "educationOptions",
  OCCUPATION: "occupationOptions",
};

export const ENTITY_TYPES_ARRAY: string[] = Object.keys(ENTITY_TYPES);

export const MEMBER_STATUS_ENUM = Object.freeze({
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  UPDATE_REQUESTED: "update_requested",
  UPDATE_REJECTED: "update_rejected",
  DECEASED: "deceased",
});

export const MOBILE_NUMBER_SUFFIX = "+";

export const MUMBAI_LOCATION = {
  lat: 19.076,
  lng: 72.8777,
};

export const PASSWORD_PLACEHOLDER = "x x x x x x x x x x";

export const REGEX = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const SIDEBAR_ROUTE_CONFIG = {
  CLIENT_ONLY: "client_only",
  SERVER_ONLY: "server_only",
  SERVER_CLIENT: "server_client",
};

export const SPECIFY_OTHERS_DROPDOWN_OPTION = {
  label: "Specify other",
  value: "specifyOthers",
};

export const START_OF_TIME_DATE = new Date(0).toISOString();

export const INDIAN_STATES: string[] = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const STATE_DROPDOWN_OPTIONS = (): DropdownType[] =>
  getDropdownDataFromArray(INDIAN_STATES);

export const TODAY_DATE = new Date().toISOString();
